<template>
  <div class="welcome">
    <div class="welcome__icon">🎉</div>
    <h2 class="welcome__title">가입을 환영해요!</h2>
    <p class="welcome__desc">이제 매일의 순간을 기록해보세요.</p>
    <div class="btn-wrap">
      <button class="btn btn--primary" @click="$router.push('/loginPage')">로그인하러 가기</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welcomePage',
}
</script>

<style scoped>
.welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 104px);
  text-align: center;
}
.welcome__icon { font-size: 5rem; margin-bottom: 1.6rem; }
.welcome__title {
  font-size: 2.4rem;
  font-weight: 800;
  color: var(--color-accent);
  margin-bottom: 1rem;
}
.welcome__desc {
  font-size: 1.4rem;
  color: var(--color-text-sub);
  margin-bottom: 2rem;
}
</style>
